import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from 'clsx';
import * as React from 'react';
const Button = React.forwardRef(({ className, variant = 'default', size = 'default', ...props }, ref) => {
    return (_jsx("button", { className: clsx('inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors', 'focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2', 'disabled:opacity-50 disabled:pointer-events-none', {
            'bg-blue-600 text-white hover:bg-blue-700': variant === 'default',
            'border border-gray-300 bg-white hover:bg-gray-50': variant === 'outline',
            'hover:bg-gray-100': variant === 'ghost',
            'bg-red-600 text-white hover:bg-red-700': variant === 'destructive',
            'h-10 py-2 px-4': size === 'default',
            'h-9 px-3': size === 'sm',
            'h-11 px-8': size === 'lg',
        }, className), ref: ref, ...props }));
});
Button.displayName = 'Button';
export { Button };
